<template>
  <v-container class="fill-height light-green" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" xs8 sm="5" md="3">
          <form @submit.prevent="onsubmit"> 
          <v-card class="elevation-12">
            <v-toolbar  color="green" flat dark>          
              <img src="@/app/assets/logo.png" style="height:40px;" />              
              <v-toolbar-title>Signup {{$config.title}}</v-toolbar-title>             
            <!--<v-tooltip bottom>
                <template v-slot:activator="{ on }">
                <v-btn
                    :href="source"
                    icon
                    large
                    target="_blank"
                    v-on="on"
                >
                    <v-icon>mdi-code-tags</v-icon>
                </v-btn>
                </template>
                <span>Source</span>
            </v-tooltip>-->                
            </v-toolbar>
            <v-card-text>            
              <v-text-field
                label="Email"
                v-model="email"
                prepend-icon="email"
                type="email"
                :error="!!emailErrors.length"
                :error-messages="emailErrors"
                ></v-text-field>

                <v-text-field
                label="Username"
                v-model="username"
                prepend-icon="person"
                type="text"
                :error="!!usernameErrors.length"
                :error-messages="usernameErrors"
                ></v-text-field>

                <v-text-field
                id="password"
                label="Password"
                v-model="password"
                prepend-icon="lock"
                type="password"
                :error="!!passwordErrors.length"
                :error-messages="passwordErrors"
                ></v-text-field>

                <v-text-field
                id="password"
                label="Retype Password"
                v-model="repassword"
                prepend-icon="lock"
                type="password"
                :error="!!retypePasswordErrors.length"
                :error-messages="retypePasswordErrors"
                ></v-text-field>
           
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="loading" type="submit">Signup</v-btn>
          </v-card-actions>
        </v-card>
        </form>
      </v-col>
    </v-row>
  </v-container>    
</template>
<script>
import model from '@/utils/models/User'
export default {
    props: {
      source: String,
    },
    data : () => ({
      email     : null,      
      username  : null,      
      password  : null,      
      repassword: null,      
      loading   : false,
      
      usernameErrors: [],
      emailErrors: [],
      passwordErrors: [],
      retypePasswordErrors: [],
    }),
    computed: {
      formReady () {
        return !this.usernameErrors.length && !this.passwordErrors.length && !this.emailErrors.length && !this.retypePasswordErrors.length
      },
    },
    methods:{
      onsubmit () {
        this.usernameErrors = this.username ? [] : ['Username is required']
        this.emailErrors = this.email ? [] : ['Email is required']
        this.passwordErrors = this.password ? [] : ['Password is required']
        this.retypePasswordErrors = this.repassword ? [] : ['Retype Password is required']
        if (!this.formReady) {
          return
        }
        this.loading = true;
        model.create(this.username, this.email, this.password, this.repassword).then(res=>{
        this.loading = false;
          if(res.status === 200 && res.data){
            window.getApp.$emit('showSnackbar', {show:true, text :'Your Signup is Successfully, please login next.', color: 'green'});
            model.set(res.data);   
            this.$router.replace({ name: 'signin' })
          } else {
            this.validate(res.data);
            return;
          }
        });      
      },

      validate(data){      
        for(var i in data){        
          if(Array.isArray(this[data[i]['field'] + 'Errors'])){          
            this[data[i]['field'] + 'Errors'].push(data[i]['message']);
          }        
        }
      }
    }
  }
</script>